<template>
  <footer>
    <div class="container footer-text">
      <span>
        Learning ECO system.<br />
        © Cambridge Technology Partners Limited.
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "LecoFooter"
};
</script>

<style scoped>
footer {
  margin-top: auto;
}
.footer-text {
  text-align: center;
  height: 60px;
  color: #343a40;
  font-size: 80%;
}
</style>
